import { ActionTypes }  from '../actions/types';
import { lrsStateType } from '../types/reducer';
import { DateTime }     from 'luxon';

const now  = DateTime.local();

export const initialLrsState: lrsStateType = {
  entryTime: now
};

const lrsReducer = (state = initialLrsState, action: ActionTypes) => {

  switch (action.type) {


//SET_LRS_STATE   -      -      -      -      -      -      -      -      -      -      -      -


case 'SET_LRS_STATE':
  {

    const { entryTime } = action.payload;
    return {
        entryTime: entryTime
    }
  }


// -      -      -      -      -      -      -      -      -      -      -      -




    default: return state;
  }
};

export type reducerType = ReturnType<typeof lrsReducer>;

export { lrsReducer };
